import { Component, computed, Input, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';
import { Market } from './interface';
import { MarketFilterService } from './market-filter.service';

@Component({
  template: `
    <ng-container *ngIf="selectedMarketText(); else loading">
      <span>
        {{ selectedMarketText() }}
      </span>
    </ng-container>
    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  `,
  providers: [],
  styleUrls: ['./market-filter-chip.component.scss'],
  imports: [CommonModule, TranslateModule],
  standalone: true,
})
export class MarketFilterChipComponent implements GalaxyAbstractFilterChip {
  selectedGroupId = signal<string>('');
  selectedMarket = signal<Market | null>(null);
  @Input() set initialValue(value: GalaxyFilterValueInterface[]) {
    if (value?.length > 0 && value[0].string) {
      this.selectedGroupId.set(value[0].string);
    }
  }

  selectedMarketText = computed(() => {
    if (!this.selectedMarket()) {
      return '';
    }
    return this.selectedMarket()?.name || this.selectedGroupId();
  });

  constructor(private readonly marketFilterService: MarketFilterService) {
    combineLatest([toObservable(this.selectedGroupId), this.marketFilterService.getAllMarkets()])
      .pipe(
        map(([groupId, allMarkets]: [string, Market[]]) => {
          return allMarkets.find((m) => m.market_id === groupId) || null;
        }),
        takeUntilDestroyed(),
      )
      .subscribe((result) => {
        this.selectedMarket.set(result);
      });
  }
}
